import { getRefreshToken, resetTokens, setAccessToken, setRefreshToken } from "./tokens";

/**
 * Refresh the access token using the stored refresh token. Concurrent callers
 * share a single in-flight request (no refresh storm). Returns true on success.
 */
let inFlight: Promise<boolean> | null = null;

async function doRefresh(): Promise<boolean> {
  const refresh = getRefreshToken();
  if (!refresh) return false;
  try {
    const resp = await fetch("/api/v1/auth/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });
    if (!resp.ok) {
      resetTokens();
      return false;
    }
    const data = (await resp.json()) as { access?: string; refresh?: string };
    if (data.access) setAccessToken(data.access);
    if (data.refresh) setRefreshToken(data.refresh); // rotation
    return Boolean(data.access);
  } catch {
    return false;
  }
}

export function refreshAccessToken(): Promise<boolean> {
  if (!inFlight) {
    inFlight = doRefresh().finally(() => {
      inFlight = null;
    });
  }
  return inFlight;
}
